import { Controller } from "@hotwired/stimulus"
import { get } from '@rails/request.js'

// Connects to data-controller="configs--presets"
export default class extends Controller {
  static targets = ['period', 'count', 'countLbl', 'comparison', 'range', 'mode', 'status']

  static values = {
    path: String,
    count: { type: Number, default: 1 }
  }

  connect() {
    app.configsForm ??= {}
    app.configsForm.presets = this
    this.updateCount()
    this.hideStatus()
  }

  add() {
    this.countValue += 1
    this.updateCount()
    this.load()
  }

  remove() {
    this.countValue -= 1
    this.updateCount()
    this.load()
  }

  load() {
    this.showStatus()
    get(this.pathValue, { query: this.query, responseKind: "turbo-stream" }).then(() => this.hideStatus())
  }

  updateCount() {
    if (this.hasCountTarget) {
      this.countTarget.value = this.countValue
    }
    if (this.hasCountLblTarget) {
      this.countLblTarget.textContent = this.countValue
    }
  }

  switchMode() {
    if (this.mode == 'preset') {
      this.modeTarget.value = 'custom'
      this.load()
    } else {
      this.modeTarget.value = 'preset'
      this.load()
    }
  }

  hideStatus() {
    this.statusTarget.classList.add('hidden')
  }

  showStatus() {
    this.statusTarget.classList.remove('hidden')
  }

  get period() {
    return this.periodTarget.value
  }

  get comparison() {
    return this.comparisonTarget.value
  }

  get mode() {
    return this.modeTarget.value
  }

  get query() {
    return {
      period: this.period,
      comparison: this.comparison,
      follow_count: this.countValue,
      mode: this.mode
    }
  }
}
